import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import Ripple from 'vuetify/lib/directives/ripple'
import preset from './default-preset/preset'

Vue.use(Vuetify)

// Ensure ripple directive is globally available (fixes "Failed to resolve directive: ripple" when using v-simple-checkbox inside v-data-table slots)
Vue.directive('ripple', Ripple)

export default new Vuetify({
  preset,
  icons: {
    iconfont: 'mdiSvg',
  },
  theme: {
    options: {
      customProperties: true,
      variations: false,
    },
  },
})
